export enum NotificationType {
   Info = 'info',
   Danger = 'danger',
   Success = 'success',
   Warning = 'warning',
}
export interface Notification {
   key?: string;
   title?: string;
   type?: NotificationType;
   timeout?: number;
   action?: () => void;
   actionText?: string;
}
